import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  styled,
  TableBody,
  TableCell,
  Avatar,
  Box,
  Skeleton,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React, { useCallback, useRef, useState } from "react";
import styles from "./Nurture.module.css";
import { tableCellClasses } from "@mui/material/TableCell";
import { useAuthUser } from "react-auth-kit";
import LeadCardDropdown from "./LeadCardDropdown/LeadCardDropdown";
import noFilteredLeadsImg from "../components/Assets/noLeadsImg.svg";
import {
  checkSubDomainAccess,
  getSubDomainAccessStatus,
} from "../../../../components/RolePermissionAccess/RolePermissionAccess";
import {
  updateEnquiryProfileTag,
  updateLeadAssignee,
  updateLeadPriority,
  updateLeadSwimlaneStatus,
  getLeadTaskList,
} from "../service/nurtureSlice";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { setToastNotification } from "../../../../components/ToastNotification/service/toastNotificationSlice";
import { updateTaskAssignee } from "../../Tasks/service/tasksSlice";
import getTeamMember, {
  getDescriptionWithMentionedNames,
  mergeFilters,
} from "../../../../components/CommonFunctions/CommonFunctions";
import {
  TableComponents,
  TableVirtuoso,
  TableVirtuosoHandle,
} from "react-virtuoso";
import moment from "moment";
import PillDropdown from "../../../../components/PillsDropdown/PillsDropdown";
import { getEnquiryTags, createEnquiryTag } from "../../../app/Settings/service/settingsSlice";
import openDrawerIcon from "../../../../assets/images/openDrawerNotes.svg";
import NotesTaskDrawer from "./NotesTaskDrawer";
import PaymentPopupFromConversion from "./PaymentPopupFromConversion";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { openLeadExpandModal } from "../../../../components/LeadPopup/hooks/useLeadCard";
import {
  GetLeadById,
  GetNurtureLeadsByOpenSearch,
} from "../service/nurture.request";
import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";
import ArrowCircleUpIcon from "@mui/icons-material/ArrowCircleUp";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#F5F5F5",
    color: "#667085",
    borderBottom: "10px solid #f5f5f5",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    borderBottom: "5px solid #f5f5f5",
  },
}));

const nurtureList = [
  {
    name: "Olivia Rhye",
    id: "l1",
    email: "oliviarhye@gmail.com",
    phoneNumber: 85459575855,
    stage: "New Enquiry",
    assignee: "Davidson",
    priority: "Urgent",
    source: "WhatsApp",
  },
  {
    name: "Olivia Rhye",
    id: "l2",
    email: "oliviarhye@gmail.com",
    phoneNumber: 85459575855,
    stage: "New Enquiry",
    assignee: "Davidson",
    priority: "Urgent",
    source: "WhatsApp",
  },
  {
    name: "Olivia Rhye",
    id: "l3",
    email: "oliviarhye@gmail.com",
    phoneNumber: 85459575855,
    stage: "New Enquiry",
    assignee: "Davidson",
    priority: "Urgent",
    source: "WhatsApp",
  },
  {
    name: "Olivia Rhye",
    id: "l4",
    email: "oliviarhye@gmail.com",
    phoneNumber: 85459575855,
    stage: "New Enquiry",
    assignee: "Davidson",
    priority: "Urgent",
    source: "WhatsApp",
  },
  {
    name: "Olivia Rhye",
    id: "l5",
    email: "oliviarhye@gmail.com",
    phoneNumber: 85459575855,
    stage: "New Enquiry",
    assignee: "Davidson",
    priority: "Urgent",
    source: "WhatsApp",
  },
  {
    name: "Olivia Rhye",
    id: "l6",
    email: "oliviarhye@gmail.com",
    phoneNumber: 85459575855,
    stage: "New Enquiry",
    assignee: "Davidson",
    priority: "Urgent",
    source: "WhatsApp",
  },
];

const NurtureList = (props: any) => {
  const {
    handleDragStart,
    hasMoreData,
    setHasMoreData,
    GetLeadNoteList,
    CreateTask,
    CreateNote,
    EditTask,
    DeleteTask,
    UpdateTaskStatus,
    leadTaskList,
    employees,
    taskTypes,
    EditNote,
    DeleteNote,
    leadNoteList,
    leadItems,
    GetLeadTaskList,

    lead,

    UpdateLeadPriority,
    setValue,
    setExpandedLead,
    setLeadSearchTerm,
    leadSearchTerm,
    filterCheckedBranches,
    filterCheckedBatches,
    filterCheckedPriorities,
    filterCheckedSources,
    filterCheckedAssignees,
    selectedCourse,
    courseLeadCount,
    UpdateLeadSwimlaneStatus,
    UpdateLeadEnquiyStatus,
    filterCheckedStages,
    leadPaginationLoad,
    paginatedLeadId,
    setPaginatedLeadId,
    lastEvaluatedKey,
    leadListItems,
    allLeadsEmpty,
    nurtureLeadStatus,
    filterApplied,
    selectedCourseForMoving,
    setSelectedCourseForMoving,
    isCheckboxChecked,
    setIsCheckboxChecked,
    selectedContacts,
    setSelectedContacts,
    leadStatusUpdateSuccess,
    setLeadListItems,
    defaultLeadsCall,
    sortingOrder,
    setSortingOrder,
    sortingLeadsCall,
    sortingOrderForLastActivity,
    setSortingOrderForLastActivity,
    defaultIconForLast,
    setDefaultIconForLast,
    defaultIcon,
    setDefaultIcon,
    draggedLeadInfo,
    setDraggedLeadInfo,
    customFieldsForFilter,
    hasSelfAssignedLeadOnly,
  } = props;

  const auth = useAuthUser();
  const authUser = auth();
  const dispatch = useDispatch();

  const { userById } = useSelector((state: any) => state.userDetails);
  const [openDrawerModal, setDrawerModal] = useState<boolean>(false);
  const [itemForNotesTask, setItemForNotesTask] = useState<any>();
  const [openConversionPaymentPopup, setOpenConversionPaymentPopup] =
    useState(false);
  const [showAssigneeConfirmation, setShowAssigneeConfirmation] = useState<boolean>(false);
  const [pendingAssignee, setPendingAssignee] = useState<any>(null);
  const [pendingLeadId, setPendingLeadId] = useState<string | null>(null);
  const [originalAssigneeId, setOriginalAssigneeId] = useState<string | null>(null);
  const isUpdatingTasksRef = useRef<boolean>(false);

  const hasLeadAccess = getSubDomainAccessStatus(
    "NURTURE_BOARD",
    "LEAD_CARD",
    "ALL_ACCESS",
    userById?.rolePermission,
  );

  const hasCustomizeAllAccess = getSubDomainAccessStatus(
    "SETTINGS",
    "CUSTOMIZE",
    "ALL_ACCESS",
    userById?.rolePermission,
  );

  const hasLeadCardPermission = checkSubDomainAccess(
    "NURTURE_BOARD",
    "LEAD_CARD",
    userById?.rolePermission,
  );
  const { onLeadsLoading, onLeadsData } = useSelector(
    (state: any) => state.nurture,
  );

  const { enquiryTags, createEnquiryTagLoading, createEnquiryTagSuccess } = useSelector(
    (state: any) => state.appSettings
  );

  const pendingCustomTagRef = useRef<{ tagName: string; leadId: string } | null>(null);

  const instituteFromLocalStorage = JSON.parse(
    localStorage.getItem("ACTIVE_INSTITUTE")!
  );
  const instituteId = instituteFromLocalStorage?.id;

  React.useEffect(() => {
    if (instituteId) {
      dispatch(getEnquiryTags(instituteId) as any);
    }
  }, [instituteId]);

  React.useEffect(() => {
    if (createEnquiryTagSuccess && instituteId) {
      dispatch(getEnquiryTags(instituteId) as any);

      if (pendingCustomTagRef.current) {
        const { tagName, leadId } = pendingCustomTagRef.current;
        pendingCustomTagRef.current = null;
        dispatch<any>(
          updateEnquiryProfileTag({
            updatedByName: authUser?.firstName + " " + authUser?.lastName,
            updatedById: authUser?.institute[0]?.id,
            enquiryProfileTag: tagName?.toUpperCase().replace(/\s+/g, "_"),
            enquiryId: leadId,
            instituteId: authUser?.institute?.[0]?.instituteId,
          })
        );
      }
    }
  }, [createEnquiryTagSuccess]);

  const allTags = React.useMemo(() => {
    const systemTags = enquiryTags?.systemTags ?? [];
    const customTags = enquiryTags?.customTags ?? [];
    return [...systemTags, ...customTags];
  }, [enquiryTags]);

  const tagOptions = React.useMemo(() => {
    const options = [];

    if (hasCustomizeAllAccess) {
      const customOption = {
        value: "custom",
        label: "Custom",
        icon: <SettingsOutlinedIcon sx={{ fontSize: 16, marginRight: "6px", color: "#11C89B" }} />,
        isCustom: true,
      };
      options.push(customOption);
    }

    return [
      ...options,
      ...allTags.map((tag: any, index: number) => ({
        value: index,
        label: tag.tagName,
      })),
    ];
  }, [allTags]);

  const getTagLabel = React.useCallback(
    (tagValue: string) => {
      const tag = allTags.find(
        (t: any) => t.tagName?.toUpperCase().replace(/\s+/g, "_") === tagValue
      );
      return tag?.tagName ?? "";
    },
    [allTags]
  );

  const getTagValue = React.useCallback(
    (tagLabel: string) => {
      const tag = allTags.find(
        (t: any) => t.tagName?.toLowerCase() === tagLabel?.toLowerCase()
      );
      return tag
        ? tag.tagName?.toUpperCase().replace(/\s+/g, "_")
        : "";
    },
    [allTags]
  );

  const [openRows, setOpenRows] = useState(
    Array(nurtureList.length).fill(false),
  );
  const [activeTab, setActiveTab] = useState<number>(0);

  const handleRowToggle = (index: number) => {
    const newOpenRows = Array(nurtureList.length).fill(false);
    newOpenRows[index] = !openRows[index];
    setOpenRows(newOpenRows);
  };

  const handleLeadPriority = React.useCallback(
    (leadId: any, leadPriority: any) => {
      if (leadPriority !== undefined) {
        if (leadId && leadPriority) {
          dispatch<any>(
            updateLeadPriority({
              enquiryId: leadId,
              enquiryPriority:
                leadPriority?.label === "Urgent"
                  ? "URGENT"
                  : leadPriority?.label === "High"
                    ? "HIGH"
                    : leadPriority?.label === "Normal"
                      ? "NORMAL"
                      : "LOW",
              updatedByName: authUser?.firstName + " " + authUser?.lastName,
              updatedById: authUser?.institute?.[0]?.id,
              instituteId: authUser?.institute?.[0]?.instituteId,
            }),
          );
        }
      }
    },
    [updateLeadPriority],
  );
  const filteredLeads =
    leadListItems &&
    leadListItems?.items?.filter((data: any) => {
      if (selectedCourse === null || selectedCourse?.courseId === "ALL") {
        return true;
      }
      return data.courseId === selectedCourse.courseId;
    });

  React.useEffect(() => {
    if (paginatedLeadId) {
      const element = document.getElementById(paginatedLeadId);
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "start",
        });
      }

      const timeoutId = setTimeout(() => {
        setPaginatedLeadId("");
      }, 2000);

      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, [leadListItems]);

  React.useEffect(() => {
    if (onLeadsLoading === true) {
      setExpandedLead(null);
      setOpenRows(Array(nurtureList.length).fill(false));
    }
  }, [onLeadsLoading]);

  interface CustomTableComponents extends TableComponents<any> {
    Table: React.FC<any>;
    TableHead: typeof TableHead;
    TableRow: React.FC<any>;
    TableBody: React.ForwardRefExoticComponent<any>;
  }
  const VirtuosoTableComponents: CustomTableComponents = {
    // Scroller: React.forwardRef<HTMLDivElement>((props, ref) => (
    // <TableContainer
    // // component={Paper}
    // {...props}
    // ref={ref}
    // className={styles.listTableContainer}
    // />
    // )),
    Table: (props) => (
      <Table {...props} style={{ borderCollapse: "separate" }} />
    ),
    TableHead: (props: any) => (
      <TableHead {...props} className={styles.batchPopupHead} />
    ),
    TableRow: ({ item, ...props }) => {
      return (
        <>
          <TableRow
            draggable
            onDragStart={(event: any) =>
              handleDragStart(event, "contacted", item.id, item)
            }
            id={item?.id}
            sx={{
              borderRadius: "2px",
              backgroundColor: item?.status === "LOST" ? "#F4EDED" : "#FFFFFF",
              border:
                item?.status === "LOST"
                  ? "1px solid #F1B3B3"
                  : "1px solid #F0F0F0",
              margin: "10px 0 !important",
            }}
            {...props}
          />
        </>
      );
    },
    TableBody: React.forwardRef<HTMLTableSectionElement>((props, ref) =>
      leadSearchTerm === "" &&
        leadListItems?.items?.length === 0 &&
        filterApplied === true &&
        courseLeadCount !== 0 &&
        onLeadsData !== null ? (
        <TableBody {...props} ref={ref}>
          <div
            style={{
              position: "absolute",
              top: "0",
              left: "0",
              right: "0",
              bottom: "0",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: "999",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <img
                style={{ width: "56px", marginBottom: "10px" }}
                src={noFilteredLeadsImg}
                alt="noFilteredLeadsImg"
              />
              <div
                style={{
                  color: "#667085",
                  fontSize: "14px",
                  fontWeight: "600",
                  marginBottom: "8px",
                  textTransform: "capitalize",
                  textAlign: "center",
                }}
              >
                No data available
              </div>
              <div
                style={{
                  color: "#667085",
                  fontSize: "13px",
                  fontWeight: "500",
                  textAlign: "center",
                }}
              >
                Try applying a different filter
              </div>
            </div>
          </div>
        </TableBody>
      ) : (
        <TableBody {...props} ref={ref} />
      ),
    ),
  };

  const handleCheckboxToggle = (contactId: string) => {
    setSelectedContacts((prevSelectedContacts: any) => {
      if (prevSelectedContacts.includes(contactId)) {
        const updatedContacts = prevSelectedContacts.filter(
          (id: any) => id !== contactId,
        );
        setIsCheckboxChecked(updatedContacts.length > 0);
        return updatedContacts;
      } else {
        setIsCheckboxChecked(true);
        return [...prevSelectedContacts, contactId];
      }
    });
  };

  const handleCourseToggle = (row: any) => {
    setSelectedCourseForMoving((prevSelectedCourse: any) => {
      if (prevSelectedCourse.includes(row)) {
        const updatedCourses = prevSelectedCourse?.filter(
          (ds: any) => ds?.id !== row?.id,
        );
        setIsCheckboxChecked(updatedCourses.length > 0);
        return updatedCourses;
      } else {
        setIsCheckboxChecked(true);
        return [...prevSelectedCourse, row];
      }
    });
  };

  const handleLeadAssignee = useCallback(
    (leadId: any, user: any) => {
      if (user !== undefined) {
        if (leadId && user) {
          dispatch<any>(
            updateLeadAssignee({
              enquiryId: leadId,
              teamMemberId: user.value,
              teamMemberName: user.label,
              updatedByName: authUser?.firstName + " " + authUser?.lastName,
              updatedById: authUser?.institute[0]?.id,
              instituteId: authUser?.institute[0]?.instituteId,
            }),
          );
        }
      }
    },
    [updateLeadAssignee, authUser],
  );

  const loginUserBranch = authUser?.institute?.[0]?.branchId;

  const hasAllBranchAccess = getSubDomainAccessStatus(
    "GLOBAL_PERMISSIONS",
    "BRANCH_ACCESS",
    "ALL_BRANCHES",
    userById?.rolePermission,
  );

  const filteredUsers =
    employees &&
    employees
      ?.filter((user: any) => {
        return user.status === "ACTIVE" && user?.leadCardAccess === true;
      })
      ?.filter((item: any) =>
        !hasAllBranchAccess ? item.branchId === loginUserBranch : true,
      );

  const handleConfirmAssigneeChange = useCallback(async () => {
    if (pendingAssignee && pendingLeadId) {
      dispatch<any>(
        updateLeadAssignee({
          enquiryId: pendingLeadId,
          teamMemberId: pendingAssignee.value,
          teamMemberName: pendingAssignee.label,
          updatedByName: authUser?.firstName + " " + authUser?.lastName,
          updatedById: authUser?.institute[0]?.id,
          instituteId: authUser?.institute[0]?.instituteId,
        })
      );

      setLeadListItems((prev: any) => {
        if (!prev || !prev.items) return prev;
        return {
          ...prev,
          items: prev.items.map((item: any) =>
            item.id === pendingLeadId
              ? {
                ...item,
                assignedToId: pendingAssignee.value,
              }
              : item
          ),
        };
      });

      if (!isUpdatingTasksRef.current) {
        isUpdatingTasksRef.current = true;

        const updateTasksForLead = async () => {
          try {
            const tasksResult = await dispatch<any>(getLeadTaskList(pendingLeadId));
            const tasks = tasksResult.payload;

            const newAssignee = filteredUsers?.find((user: any) => user.id === pendingAssignee.value);

            if (tasks && Array.isArray(tasks) && tasks.length > 0 && newAssignee) {
              const updatePromises = tasks.map((task: any) => {
                return dispatch<any>(updateTaskAssignee({
                  taskId: task.id,
                  assignedToId: pendingAssignee.value,
                  assignedToName: `${newAssignee.firstName} ${newAssignee.lastName}`,
                }));
              });
              await Promise.all(updatePromises);
            }
          } catch (error) {
            console.error("Error updating task assignees:", error);
          } finally {
            isUpdatingTasksRef.current = false;
          }
        };

        updateTasksForLead();
      }

      setPendingAssignee(null);
      setPendingLeadId(null);
      setOriginalAssigneeId(null);
      setShowAssigneeConfirmation(false);
    }
  }, [pendingAssignee, pendingLeadId, authUser, dispatch, filteredUsers, setLeadListItems]);

  const handleCancelAssigneeChange = useCallback(() => {
    setPendingAssignee(null);
    setPendingLeadId(null);
    setOriginalAssigneeId(null);
    setShowAssigneeConfirmation(false);
  }, []);

  const handleUpdatingSwimlaneStatus = useCallback(
    (leadId: any, info: any) => {
      if (info !== undefined) {
        dispatch<any>(
          updateLeadSwimlaneStatus({
            enquiryId: leadId,
            swimlaneStatus:
              info?.label === "New Enquiry"
                ? "NEW_ENQUIRY"
                : info?.label === "Demo"
                  ? "DEMO"
                  : info?.label === "Contacted"
                    ? "CONTACTED"
                    : info?.label === "Negotiation"
                      ? "NEGOTIATION"
                      : "CONVERTED",
            updatedByName: authUser?.firstName + " " + authUser?.lastName,
            updatedById: authUser?.institute[0]?.id,
            instituteId: authUser?.institute[0]?.instituteId,
          }),
        );
      }
    },
    [updateLeadSwimlaneStatus],
  );

  const handleUpdatingEnquiryProfileTag = useCallback(
    (leadId: any, info: any) => {
      if (info !== undefined) {
        dispatch<any>(
          updateEnquiryProfileTag({
            updatedByName: authUser?.firstName + " " + authUser?.lastName,
            updatedById: authUser?.institute[0]?.id,
            enquiryProfileTag: getTagValue(info?.label),
            enquiryId: leadId,
            instituteId: authUser?.institute?.[0]?.instituteId,
          })
        );
      }
    },
    [updateEnquiryProfileTag, getTagValue]
  );

  const handleCustomTagAdd = useCallback(
    (tagName: string, leadId: string) => {
      const instituteId = authUser?.institute?.[0]?.instituteId;
      if (tagName && instituteId && hasCustomizeAllAccess) {
        pendingCustomTagRef.current = { tagName, leadId };
        dispatch<any>(
          createEnquiryTag({
            tagName: tagName,
            instituteId: instituteId,
            createdById: authUser?.institute?.[0]?.id,
            createdByName: authUser?.firstName + " " + authUser?.lastName,
          })
        );
      }
    },
    [authUser, hasCustomizeAllAccess]
  );

  React.useEffect(() => {
    if (leadStatusUpdateSuccess === "Please record a payment to continue.") {
      setOpenConversionPaymentPopup(true);
    }
  }, [leadStatusUpdateSuccess]);

  const handleAscending = (value: string) => {
    sortingLeadsCall(
      true,
      nurtureLeadStatus,
      selectedCourse?.courseId,
      value,
      "asc",
    );

    setSortingOrder("asc");
    setSortingOrderForLastActivity("desc");

    const queryParams = new URLSearchParams(window.location.search);
    setDefaultIcon(false);
    setDefaultIconForLast(true);

    setDefaultIconForLast(false);
    setDefaultIcon(true);
    queryParams.set("sortingOrder", "asc");
    queryParams.set("sortingKey", value);
    const queryString = queryParams.toString();
    const newUrl = `${window.location.pathname}${queryString ? `?${queryString}` : ""
      }`;
    window.history.pushState({}, "", newUrl);
  };

  const handleAscendingLastActivity = (value: string) => {
    sortingLeadsCall(
      true,
      nurtureLeadStatus,
      selectedCourse?.courseId,
      value,
      "asc",
    );

    setSortingOrderForLastActivity("asc");
    setSortingOrder("desc");

    const queryParams = new URLSearchParams(window.location.search);

    setDefaultIconForLast(false);
    setDefaultIcon(true);
    queryParams.set("sortingOrder", "asc");
    queryParams.set("sortingKey", value);
    const queryString = queryParams.toString();
    const newUrl = `${window.location.pathname}${queryString ? `?${queryString}` : ""
      }`;
    window.history.pushState({}, "", newUrl);
  };

  const handleDescending = (value: string) => {
    sortingLeadsCall(
      true,
      nurtureLeadStatus,
      selectedCourse?.courseId,
      value,
      "desc",
    );

    setSortingOrder("desc");
    setSortingOrderForLastActivity("desc");

    const queryParams = new URLSearchParams(window.location.search);

    setDefaultIcon(false);

    queryParams.set("sortingOrder", "desc");
    queryParams.set("sortingKey", value);
    const queryString = queryParams.toString();
    const newUrl = `${window.location.pathname}${queryString ? `?${queryString}` : ""
      }`;
    window.history.pushState({}, "", newUrl);
  };

  const handleDescendingLastActivity = (value: string) => {
    sortingLeadsCall(
      true,
      nurtureLeadStatus,
      selectedCourse?.courseId,
      value,
      "desc",
    );
    setSortingOrder("desc");

    setSortingOrderForLastActivity("desc");
    const queryParams = new URLSearchParams(window.location.search);

    setDefaultIconForLast(false);
    setDefaultIcon(true);
    queryParams.set("sortingOrder", "desc");
    queryParams.set("sortingKey", value);
    const queryString = queryParams.toString();
    const newUrl = `${window.location.pathname}${queryString ? `?${queryString}` : ""
      }`;
    window.history.pushState({}, "", newUrl);
  };

  const { leadUpdateNotify, taskUpdateNotify } = useSelector(
    (state: any) => state?.websocketNotifications,
  );
  const isRefreshing = leadUpdateNotify === true || taskUpdateNotify === true;
  const [disableArrow, setDisableArrow] = useState(false);

  const handleNextPage = (columnDetails: any) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const nurtureView = urlSearchParams.get("nurtureView");
    const leadStatusParam = urlSearchParams.get("nurtureLeadStatus");

    const userFromLocalStorage = authUser?.institute[0]?.instituteDetails;

    const branchParam = urlSearchParams.get("filteredBranches");
    const batchParam = urlSearchParams.get("filteredBatches");
    const assigneeParam = urlSearchParams.get("filteredAssignees");
    const priorityParam = urlSearchParams.get("filteredPriorities");
    const sourceParam = urlSearchParams.get("filteredSources");
    const stagesParam = urlSearchParams.get("filteredStages");
    const tagsParam = urlSearchParams.get("filteredTags");

    const sortingOrderFromUrl: any = urlSearchParams.get("sortingOrder");
    const sortingKey: any = urlSearchParams.get("sortingKey");
    if (sortingKey === "lastAssignedOnDate") {
      setSortingOrder(sortingOrderFromUrl);
      setDefaultIconForLast(true);
      setDefaultIcon(false);
    } else if (sortingKey === "lastActivityDate") {
      setSortingOrderForLastActivity(sortingOrderFromUrl);
      setDefaultIconForLast(false);
      setDefaultIcon(true);
    } else {
      setDefaultIconForLast(true);
      setDefaultIcon(true);
    }
    const prioritiesInUrl = priorityParam
      ? priorityParam.split("|").map((item: string) => item)
      : [];
    const sourcesInUrl = sourceParam
      ? sourceParam
        .split("|")
        .map((item: string) => item?.toUpperCase().replace(/\s+/g, "_"))
      : [];
    const stagesInUrl = stagesParam
      ? stagesParam.split("|").map((item: string) => item)
      : [];
    const assigneeIdInUrl = assigneeParam
      ? assigneeParam.split("|").map((item: string) => item)
      : [];
    const branchIdInUrl = branchParam
      ? branchParam.split("|").map((item: string) => item)
      : [];
    const batchIdInUrl = batchParam
      ? batchParam.split("|").map((item: string) => item)
      : [];

    const tagStatusInUrl = tagsParam
      ? tagsParam.split("|").map((item: string) => ({
        value: item,
      }))
      : [];

    const dynamicChecked: any[] = [];
    const dynamicSelect: any[] = [];
    const dynamicRadio: any[] = [];

    urlSearchParams.forEach((value, key) => {
      const predefinedKeys = [
        "filteredBranches",
        "filteredBatches",
        "filteredAssignees",
        "filteredPriorities",
        "filteredSources",
        "filteredStages",
        "filteredTags",
        "selectedCourse",
        "nurtureLeadStatus",
      ];

      if (!predefinedKeys.includes(key)) {
        const fieldMeta = customFieldsForFilter?.find(
          (f: any) => f.fieldName === key,
        );

        if (fieldMeta) {
          const parsedValue = value.split(",");
          const entry = { key, value: parsedValue };

          if (fieldMeta.fieldType === "checkbox") {
            dynamicChecked.push(entry);
          } else if (fieldMeta.fieldType === "select") {
            dynamicSelect.push(entry);
          } else if (fieldMeta.fieldType === "radio") {
            dynamicRadio.push(entry);
          }
        }
      }
    });

    if (userFromLocalStorage && selectedCourse.courseId) {
      type Data = {
        instituteId: string;
        isListView: boolean;
        isFilter: boolean;
        entityName: string;
        courseId: string;
        enquiryStatus: string;
        branchId?: any[];
        enquirySource?: any[];
        enquiryPriority?: any[];
        batchId?: any[];
        assignedToId?: any[];
        enquirySwimlaneStatus?: any[];
        enquiryProfileTag?: any[];
        additionalFilters?: any[];
        sortKey?: string;
        sortType?: string;
        pageSize?: number;
        listCursor: any;
      };

      const data: Data = {
        instituteId: userFromLocalStorage?.id,
        isFilter: true,
        isListView: nurtureView !== "LIST" ? false : true,
        entityName: "ENQUIRY",
        enquiryStatus: leadStatusParam === "LOST" ? "LOST" : "ACTIVE",
        courseId: selectedCourse.courseId,
        additionalFilters: mergeFilters([
          dynamicChecked,
          dynamicSelect,
          dynamicRadio,
        ]),
        sortKey: sortingKey ? sortingKey : "",
        sortType: sortingOrderFromUrl ? sortingOrderFromUrl : "",
        pageSize: 20,
        listCursor: columnDetails,
      };

      if (!hasAllBranchAccess) {
        data.branchId = [authUser?.institute?.[0]?.branchId];
      } else {
        data.branchId = branchIdInUrl?.length > 0 ? branchIdInUrl : [];
      }

      // if (userById?.roleCode === "COURSE_COUNSELOR") {
      // data.assignedToId = [authUser?.institute?.[0]?.id];
      // }
      if (hasSelfAssignedLeadOnly) {
        data.assignedToId = [authUser?.institute?.[0]?.id];
      } else {
        data.assignedToId = assigneeIdInUrl?.length > 0 ? assigneeIdInUrl : [];
      }

      if (sourcesInUrl) {
        data.enquirySource = sourcesInUrl?.length > 0 ? sourcesInUrl : [];
      }
      if (prioritiesInUrl) {
        data.enquiryPriority =
          prioritiesInUrl?.length > 0 ? prioritiesInUrl : [];
      }

      if (batchIdInUrl) {
        data.batchId = batchIdInUrl?.length > 0 ? batchIdInUrl : [];
      }

      if (nurtureView !== "LIST" ? false : true && stagesInUrl) {
        data.enquirySwimlaneStatus = stagesInUrl?.length > 0 ? stagesInUrl : [];
      }

      if (tagStatusInUrl) {
        data.enquiryProfileTag =
          tagStatusInUrl?.length > 0
            ? tagStatusInUrl?.map((item: any) => getTagValue(item?.value))
            : [];
        setDisableArrow(true);
        GetNurtureLeadsByOpenSearch(data)
          .then((res: any) => {
            const response = res?.data?.data;

            if (response?.items?.length) {
              setLeadListItems((prev: any) => ({
                ...prev,
                items: [...(prev.items || []), ...response.items],
                nextCursor: response.nextCursor,
                hasMore: response.hasMore,
              }));
            }
            setDisableArrow(false);
          })
          .catch((err: any) => {
            setDisableArrow(false);
          });
      }
    }
  };

  const virtuosoRef = useRef<TableVirtuosoHandle>(null);
  const [showScrollTop, setShowScrollTop] = useState(false);

  return (
    <div style={{ overflow: "auto", height: "100%" }}>
      {showScrollTop && filteredLeads?.length > 200 && (
        <button
          onClick={() => {
            virtuosoRef.current?.scrollToIndex({
              index: 0,
              align: "start",
              behavior: "smooth",
            });
          }}
          style={{
            position: "absolute",
            top: "0px",
            left: "50%",
            transform: "translateX(-50%)",
            color: "#fff",
            width: "40px",
            height: "40px",
            fontSize: "20px",
            cursor: "pointer",
            zIndex: 10,
            background: "transparent",
            border: "none",
            padding: 0,
          }}
        >
          <ArrowCircleUpIcon style={{ color: "#11C89B", height: "20px" }} />
        </button>
      )}
      {leadListItems && onLeadsData !== null ? (
        <>
          <TableVirtuoso
            atTopStateChange={(atTop) => setShowScrollTop(!atTop)}
            ref={virtuosoRef}
            style={{
              height: "calc(100vh - 180px)",
              background: "#f5f5f5",
            }}
            totalCount={filteredLeads?.length || 0}
            components={VirtuosoTableComponents}
            data={filteredLeads || []}
            fixedHeaderContent={() => (
              <TableRow>
                <StyledTableCell
                  className={styles.batchPopupHeadCell}
                  sx={{ borderBottom: "none", width: "5%", maxWidth: "5%" }}
                >
                  <Checkbox
                    sx={{
                      strokeWidth: 1,
                      color: "rgba(102, 112, 133, 0.30)",
                    }}
                    checked={
                      filteredLeads?.length > 0 &&
                      selectedContacts?.length === filteredLeads?.length
                    }
                    onChange={() => {
                      if (selectedContacts?.length === filteredLeads?.length) {
                        setIsCheckboxChecked(false);
                        setSelectedContacts([]);

                        setSelectedCourseForMoving([]);
                      } else {
                        const allEmailIds = filteredLeads?.map(
                          (item: any) => item.id,
                        );
                        const allContacts = filteredLeads?.map(
                          (item: any) => item,
                        );
                        setSelectedContacts(allEmailIds);

                        setIsCheckboxChecked(true);
                        setSelectedCourseForMoving(allContacts);
                      }
                    }}
                  />
                </StyledTableCell>
                <StyledTableCell
                  className={styles.batchPopupHeadCell}
                  sx={{
                    borderBottom: "none",
                    width: "26%",
                    maxWidth: "26%",
                  }}
                >
                  Name
                </StyledTableCell>

                <StyledTableCell
                  className={styles.batchPopupHeadCell}
                  align="left"
                  sx={{
                    borderBottom: "none",
                    minWidth: "250px",
                    maxWidth: "400px",
                  }}
                >
                  Phone Number
                </StyledTableCell>
                <StyledTableCell
                  className={styles.batchPopupHeadCell}
                  align="center"
                  sx={{
                    borderBottom: "none",
                    width: "12%",
                    maxWidth: "12%",
                  }}
                >
                  Tag
                </StyledTableCell>
                <StyledTableCell
                  className={styles.batchPopupHeadCell}
                  align="center"
                  sx={{
                    borderBottom: "none",
                    minWidth: "250px",
                    maxWidth: "400px",
                  }}
                >
                  Stage
                </StyledTableCell>
                <StyledTableCell
                  className={styles.batchPopupHeadCell}
                  align="center"
                  sx={{
                    borderBottom: "none",
                    minWidth: "250px",
                    maxWidth: "400px",
                  }}
                >
                  Assignee
                </StyledTableCell>
                <StyledTableCell
                  className={styles.batchPopupHeadCell}
                  align="center"
                  sx={{
                    borderBottom: "none",
                    minWidth: "250px",
                    maxWidth: "400px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}
                  >
                    {"Assigned On"}
                    {defaultIcon ? (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "-10",
                        }}
                      >
                        <KeyboardArrowDownIcon
                          onClick={() => handleAscending("lastAssignedOnDate")}
                          sx={{ fontSize: "20px", cursor: "pointer" }}
                        />
                      </div>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "-10",
                        }}
                      >
                        {sortingOrder === "asc" ? (
                          <ArrowDropUpIcon
                            onClick={() =>
                              handleDescending("lastAssignedOnDate")
                            }
                            sx={{ fontSize: "20px", cursor: "pointer" }}
                          />
                        ) : (
                          <ArrowDropDownIcon
                            onClick={() =>
                              handleAscending("lastAssignedOnDate")
                            }
                            sx={{ fontSize: "20px", cursor: "pointer" }}
                          />
                        )}
                      </div>
                    )}
                  </div>
                </StyledTableCell>
                <StyledTableCell
                  className={styles.batchPopupHeadCell}
                  align="left"
                  sx={{
                    borderBottom: "none",
                    minWidth: "250px",
                    maxWidth: "400px",
                  }}
                >
                  Last Note
                </StyledTableCell>
                <StyledTableCell
                  className={styles.batchPopupHeadCell}
                  align="center"
                  sx={{ borderBottom: "none", width: "10%", maxWidth: "10%" }}
                >
                  Priority
                </StyledTableCell>
                <StyledTableCell
                  className={styles.batchPopupHeadCell}
                  align="left"
                  sx={{
                    borderBottom: "none",
                    minWidth: "250px",
                    maxWidth: "400px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}
                  >
                    {"Last Activity Time"}
                    {defaultIconForLast ? (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "-10",
                        }}
                      >
                        <KeyboardArrowDownIcon
                          onClick={() =>
                            handleAscendingLastActivity("lastActivityDate")
                          }
                          sx={{ fontSize: "20px", cursor: "pointer" }}
                        />
                      </div>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "-10",
                        }}
                      >
                        {sortingOrderForLastActivity === "asc" ? (
                          <ArrowDropUpIcon
                            onClick={() =>
                              handleDescendingLastActivity("lastActivityDate")
                            }
                            sx={{ fontSize: "20px", cursor: "pointer" }}
                          />
                        ) : (
                          <ArrowDropDownIcon
                            onClick={() =>
                              handleAscendingLastActivity("lastActivityDate")
                            }
                            sx={{ fontSize: "20px", cursor: "pointer" }}
                          />
                        )}
                      </div>
                    )}
                  </div>
                </StyledTableCell>
                <StyledTableCell
                  className={styles.batchPopupHeadCell}
                  align="left"
                  style={{
                    minWidth: "250px",
                    maxWidth: "400px",
                  }}
                >
                  Source
                </StyledTableCell>
                <StyledTableCell
                  className={styles.batchPopupHeadCell}
                  sx={{
                    borderBottom: "none",
                    textAlign: "center",
                    width: "5%",
                    maxWidth: "5%",
                  }}
                >
                  {filteredLeads?.length}
                </StyledTableCell>
              </TableRow>
            )}
            itemContent={(index: number, item: any) => {
              return (
                <React.Fragment key={item?.id || index}>
                  <StyledTableCell
                    align="left"
                    sx={{
                      color: "#667085",
                      textTransform: "capitalize",
                      borderBottom: "none",
                      width: "5%",
                      maxWidth: "5%",
                    }}
                  >
                    <Checkbox
                      sx={{
                        strokeWidth: 1,
                        color: "rgba(102, 112, 133, 0.30)",
                      }}
                      checked={selectedContacts?.includes(item?.id)}
                      onChange={() => {
                        handleCheckboxToggle(item.id);
                        handleCourseToggle(item);
                      }}
                    />
                  </StyledTableCell>
                  <StyledTableCell
                    align="left"
                    sx={{
                      color: "#667085",
                      borderBottom: "none",
                      width: "26%",
                      maxWidth: "26%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "8px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <div className={styles.agentCardImg}>
                          <Avatar
                            alt="avatar"
                            sx={{
                              width: "100%",
                              height: "100%",
                              borderRadius: "50%",
                              fontSize: "17px",
                              background: "#F5F5F7",
                              border: "1px solid #EEEEF4",
                              color: "#667085",
                            }}
                          >
                            {item?.studentFirstName?.charAt(0)}
                          </Avatar>
                        </div>
                        <div>
                          <Box
                            sx={{
                              textTransform: "capitalize",
                              cursor: "pointer",
                              ":hover": {
                                color: "#11c89b",
                                transition: "0.3s",
                              },
                            }}
                            onClick={() => {
                              if (selectedCourseForMoving?.length === 0) {
                                hasLeadCardPermission
                                  ? openLeadExpandModal(
                                    item?.instituteId,
                                    item?.studentContact,
                                    item?.studentEmail,
                                    item?.id,
                                    dispatch,
                                    "",
                                  )
                                  : dispatch(
                                    setToastNotification({
                                      message:
                                        "You do not have permission to access the lead card",
                                      type: "error",
                                      snackOpen: true,
                                    }),
                                  );
                              }
                            }}
                          >
                            {`${item?.studentFirstName} ${item?.studentLastName}`}
                          </Box>
                          <div>{item?.studentEmail}</div>
                        </div>
                      </div>
                      {selectedCourseForMoving?.length === 0 && (
                        <div
                          onClick={() => {
                            GetLeadTaskList(item.id);
                            GetLeadNoteList(item.id);
                            setDrawerModal(true);
                            setItemForNotesTask(item);
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          <img src={openDrawerIcon} />
                        </div>
                      )}
                    </div>
                  </StyledTableCell>
                  <StyledTableCell
                    align="left"
                    sx={{
                      color: "#667085",
                      borderBottom: "none",
                      width: "12%",
                      maxWidth: "12%",
                    }}
                  >
                    {item?.studentContact
                      ? `+${item?.contactCountryCode || "91"} ${item?.contactCountryCode
                        ? item?.studentContact?.replace(
                          item?.contactCountryCode,
                          "",
                        )
                        : item?.studentContact?.startsWith("91")
                          ? item?.studentContact?.replace("91", "")
                          : item?.studentContact
                      }`
                      : "-"}
                  </StyledTableCell>
                  <StyledTableCell
                    align="left"
                    sx={{
                      color: "#667085",
                      borderBottom: "none",
                      width: "20%",
                      maxWidth: "20%",
                    }}
                  >
                    {item?.enquiryProfileTag ? (
                      <PillDropdown
                        value={getTagLabel(item?.enquiryProfileTag)}
                        options={tagOptions}
                        backgroundColor={"#f0edff"}
                        color={"#573de4"}
                        hoverBackgroundColor={"#e4ddff"}
                        handleSelect={handleUpdatingEnquiryProfileTag}
                        leadId={item?.id}
                        disabled={leadUpdateNotify === true}
                        onCustomAdd={handleCustomTagAdd}
                        customAddLoading={createEnquiryTagLoading}
                      />
                    ) : (
                      "-"
                    )}
                  </StyledTableCell>
                  <StyledTableCell
                    align="left"
                    sx={{
                      color: "#667085",
                      borderBottom: "none",
                      width: "20%",
                      maxWidth: "20%",
                    }}
                  >
                    <PillDropdown
                      value={item?.enquirySwimlaneStatus
                        ?.replace(/_/g, " ")
                        .toLowerCase()}
                      options={[
                        { value: 0, label: "New Enquiry" },
                        { value: 1, label: "Contacted" },
                        { value: 2, label: "Demo" },
                        { value: 3, label: "Negotiation" },
                        { value: 4, label: "Converted" },
                      ]}
                      backgroundColor={"rgba(219, 233, 253, 1)"}
                      color={"rgba(37, 68, 169, 1)"}
                      hoverBackgroundColor={"rgba(219, 233, 253, 0.8)"}
                      handleSelect={handleUpdatingSwimlaneStatus}
                      leadId={item?.id}
                      disabled={isRefreshing}
                    />
                  </StyledTableCell>
                  <StyledTableCell
                    align="left"
                    sx={{
                      color: "#667085",
                      borderBottom: "none",
                      width: "25%",
                      maxWidth: "25%",
                    }}
                  >
                    <PillDropdown
                      value={`${getTeamMember(item?.assignedToId, employees)?.firstName
                        } ${getTeamMember(item?.assignedToId, employees)?.lastName
                        }`}
                      options={
                        filteredUsers &&
                        filteredUsers?.map((d: any) => {
                          return {
                            value: d.id,
                            label: `${d?.firstName} ${d?.lastName}`,
                          };
                        })
                      }
                      backgroundColor={"#fff"}
                      color={"#667085"}
                      hoverBackgroundColor={"#fff"}
                      isEmployee={true}
                      handleSelect={handleLeadAssignee}
                      leadId={item?.id}
                      disabled={isRefreshing}
                    />
                  </StyledTableCell>
                  <StyledTableCell
                    align="left"
                    sx={{
                      color: "#667085",
                      borderBottom: "none",
                      width: "25%",
                      maxWidth: "25%",
                    }}
                  >
                    {moment(item?.lastAssignedOnDate).format(
                      "DD/MM/YYYY hh:mm A",
                    )}
                  </StyledTableCell>
                  <StyledTableCell
                    align="left"
                    sx={{
                      color: "#667085",
                      borderBottom: "none",
                      width: "20%",
                      maxWidth: "20%",
                    }}
                  >
                    <div
                      className={styles.activityDescription}
                      dangerouslySetInnerHTML={{
                        __html: item?.lastNote
                          ? item?.lastNote?.length <= 20
                            ? getDescriptionWithMentionedNames(
                              item?.lastNote,
                              filteredUsers,
                            ).replace(/\n/g, "<br>")
                            : item?.lastNote?.length >= 20
                              ? `${getDescriptionWithMentionedNames(
                                item?.lastNote,
                                filteredUsers,
                              )
                                .replace(/\n/g, "<br>")
                                ?.slice(0, 15)}...`
                              : "-"
                          : "-",
                      }}
                    />
                  </StyledTableCell>
                  <StyledTableCell
                    align="left"
                    sx={{
                      color: "#667085",
                      borderBottom: "none",
                      width: "10%",
                      maxWidth: "10%",
                    }}
                  >
                    <PillDropdown
                      value={`${item?.enquiryPriority?.toLowerCase()}`}
                      options={[
                        { value: 0, label: "Urgent" },
                        { value: 1, label: "High" },
                        { value: 2, label: "Normal" },
                        { value: 3, label: "Low" },
                      ]}
                      backgroundColor={"rgba(242, 244, 247, 1)"}
                      color={"#667085"}
                      hoverBackgroundColor={"rgba(242, 244, 247, 0.8)"}
                      isPriority={true}
                      handleSelect={handleLeadPriority}
                      leadId={item?.id}
                      disabled={isRefreshing}
                    />
                  </StyledTableCell>
                  <StyledTableCell
                    align="left"
                    sx={{
                      color: "#667085",
                      borderBottom: "none",
                      width: "30%",
                      maxWidth: "30%",
                    }}
                  >
                    {moment(item?.lastActivityDate).format(
                      "DD/MM/YYYY hh:mm A",
                    )}
                  </StyledTableCell>

                  <StyledTableCell
                    align="left"
                    sx={{
                      color: "#667085",
                      borderBottom: "none",
                      textTransform: "capitalize",
                      width: "15%",
                      minWidth: "15%",
                    }}
                  >
                    {item?.enquirySource?.replace(/_/g, " ").toLowerCase()}
                  </StyledTableCell>
                  <StyledTableCell
                    align="left"
                    sx={{
                      color: "#667085",
                      borderBottom: "none",
                      width: "5%",
                      maxWidth: "5%",
                    }}
                  >
                    {selectedCourseForMoving?.length === 0 ? (
                      <>
                        {hasLeadAccess &&
                          item?.enquirySwimlaneStatus !== "CONVERTED" && (
                            <LeadCardDropdown
                              UpdateLeadSwimlaneStatus={
                                UpdateLeadSwimlaneStatus
                              }
                              leadDetails={item}
                              UpdateLeadEnquiyStatus={UpdateLeadEnquiyStatus}
                              authUser={authUser}
                            />
                          )}
                      </>
                    ) : (
                      <></>
                    )}
                  </StyledTableCell>

                  {leadListItems?.items?.length === 0 &&
                    leadSearchTerm !== "" &&
                    courseLeadCount !== 0 &&
                    filteredLeads?.length === 0 && (
                      // <TableRow>
                      <TableCell colSpan={7} align="center">
                        No leads found with the specified search term.
                      </TableCell>
                      // </TableRow>
                    )}
                </React.Fragment>
              );
            }}
          />
          {leadListItems?.hasMore && (
            <button
              onClick={() => handleNextPage(leadListItems?.nextCursor)}
              style={{
                position: "absolute",
                bottom: "10px",
                left: "50%",
                transform: "translateX(-50%)",
                color: "#fff",
                width: "40px",
                height: "40px",
                fontSize: "20px",
                cursor: "pointer",
                zIndex: 10,
                background: "transparent",
                border: "none",
                padding: 0,
              }}
              disabled={disableArrow}
            >
              <ArrowCircleDownIcon style={{ color: "#11C89B" }} />
            </button>
          )}
        </>
      ) : (
        <div className={styles.kanbanColumn} style={{ marginBottom: "8px" }}>
          <div
            className={styles.kanbanColumnHead}
            style={{ gap: "60px", padding: "16px" }}
          >
            <Skeleton animation="wave" variant="text" width={115} height={25} />
            <Skeleton animation="wave" variant="text" width={210} height={25} />
            <Skeleton animation="wave" variant="text" width={115} height={25} />
            <Skeleton animation="wave" variant="text" width={155} height={25} />
            <Skeleton animation="wave" variant="text" width={112} height={25} />
            <Skeleton animation="wave" variant="text" width={115} height={25} />
          </div>
          {Array.from({ length: 8 }, (_, index) => (
            <div
              key={index}
              style={{
                backgroundColor: "#FFF",
                borderRadius: "2px",
                marginTop: "10px",
                height: "72px",
                padding: "16px",
                display: "flex",
                alignItems: "center",
                gap: "60px",
              }}
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "6px" }}
              >
                <Skeleton
                  animation="wave"
                  variant="circular"
                  width={30}
                  height={30}
                />
                <Skeleton
                  animation="wave"
                  variant="text"
                  width={80}
                  height={25}
                />
              </div>

              <Skeleton
                animation="wave"
                variant="text"
                width={210}
                height={25}
              />
              <Skeleton
                animation="wave"
                variant="text"
                width={110}
                height={25}
              />
              <div
                style={{ display: "flex", alignItems: "center", gap: "6px" }}
              >
                <Skeleton
                  animation="wave"
                  variant="circular"
                  width={25}
                  height={25}
                />
                <Skeleton
                  animation="wave"
                  variant="text"
                  width={125}
                  height={25}
                />
              </div>
              <div
                style={{ display: "flex", alignItems: "center", gap: "6px" }}
              >
                <Skeleton
                  animation="wave"
                  variant="circular"
                  width={25}
                  height={25}
                />
                <Skeleton
                  animation="wave"
                  variant="text"
                  width={85}
                  height={25}
                />
              </div>

              <Skeleton
                animation="wave"
                variant="text"
                width={110}
                height={25}
              />
              <Skeleton
                animation="wave"
                variant="text"
                width={15}
                height={25}
              />
            </div>
          ))}
        </div>
      )}
      {openDrawerModal && (
        <NotesTaskDrawer
          setDrawerModal={setDrawerModal}
          openDrawerModal={openDrawerModal}
          {...props}
          CreateTask={CreateTask}
          EditTask={EditTask}
          DeleteTask={DeleteTask}
          UpdateTaskStatus={UpdateTaskStatus}
          selectedLeadData={itemForNotesTask}
          leadTaskList={leadTaskList}
          employees={employees}
          taskTypes={taskTypes}
          CreateNote={CreateNote}
          EditNote={EditNote}
          DeleteNote={DeleteNote}
          leadNoteList={leadNoteList}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          GetLeadTaskList={GetLeadTaskList}
          GetLeadNoteList={GetLeadNoteList}
        />
      )}
      {openConversionPaymentPopup && (
        <PaymentPopupFromConversion
          openConversionPaymentPopup={openConversionPaymentPopup}
          setOpenConversionPaymentPopup={setOpenConversionPaymentPopup}
          draggedLeadInfo={draggedLeadInfo}
          List={true}
        />
      )}
      <Dialog
        open={showAssigneeConfirmation}
        onClose={handleCancelAssigneeChange}
        aria-labelledby="assignee-confirmation-dialog-title"
        aria-describedby="assignee-confirmation-dialog-description"
        sx={{
          zIndex: "9999999",
          "& .MuiDialog-paper": {
            zIndex: "9999999",
            minWidth: "400px",
            maxWidth: "500px",
            borderRadius: "12px",
            boxShadow:
              "0px 8px 8px -4px rgba(16, 24, 40, 0.03), 0px 20px 24px -4px rgba(16, 24, 40, 0.08)",
            padding: "24px",
          },
        }}
        BackdropProps={{
          style: {
            zIndex: "9999998",
          },
        }}
      >
        <DialogTitle
          id="assignee-confirmation-dialog-title"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "0 0 16px 0",
            "& .MuiDialogTitle-root": {
              padding: 0,
            },
          }}
        >
          <span>Confirm Assignee Change</span>
          <IconButton
            aria-label="close"
            onClick={handleCancelAssigneeChange}
            sx={{
              color: "#667085",
              padding: "4px",
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.04)",
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ padding: "0 0 16px 0" }}>
          <DialogContentText id="assignee-confirmation-dialog-description">
            Are you sure you want to change the assignee? This action will reassign all tasks to the selected assignee.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ padding: "0", gap: "8px" }}>
          <Button
            onClick={handleCancelAssigneeChange}
            color="primary"
            variant="outlined"
            sx={{
              textTransform: "capitalize",
              borderRadius: "4px",
              minWidth: "100px",
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirmAssigneeChange}
            color="primary"
            variant="contained"
            sx={{
              textTransform: "capitalize",
              borderRadius: "4px",
              minWidth: "100px",
            }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default NurtureList;
